<template>
  <div>
    <!-- HEADER -->
    <div class="form-header">
      <div class="form-header-left">
        <button class="back-circle-btn" @click="Closepage('/kirim/index')"><b-icon icon="chevron-left"></b-icon></button>
        <h2 class="page-title">{{ $t($route.name) }} <span v-if="$route.params.id != undefined">&#8470;{{ $route.params.id }}</span></h2>
        <button v-if="$route.params.id!=undefined && settedrule.change==true" class="change-btn" @click="Change()">{{$t('Ўзгартириш')}}</button>
      </div>
      <div class="form-header-right">
        <label>Курс</label>
        <input :disabled="changedisabled" type="text" v-model="datas.dollar_rate" class="kurs-input">
      </div>
    </div>

    <!-- TOP FORM BAR -->
    <div class="form-fields-bar">
      <div class="field-item">
        <label>Факт №</label>
        <input :disabled="changedisabled" type="number" class="input100" v-model="datas.number">
      </div>
      <div class="field-item">
        <label>{{$t('Вақт')}}</label>
        <input type="datetime-local" disabled="true" class="input100" :value="SetDatetime(datas.created_at)">
      </div>
      <div class="field-item" style="min-width: 160px;">
        <label>Склад</label>
        <v-select :disabled="skladhave" :clearable="false" class="form-control-sm required md-input"
          :options="skladlist" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <b>insert</b>
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item" style="min-width: 180px;">
        <label>{{ $t("Етказувчи") }}</label>
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input" :options="kontragentlist"
          v-model="datas.kontragent_id" :reduce="name => name.id" label="name">
          <template #list-footer>
            <li style="text-align: center;font-weight:bold;">
              f4 {{ $t("умумий рўйхат") }}
            </li>
          </template>
          <template #search="{ attributes, events }">
            <input class="vs__search" ref="focused" v-bind="attributes" v-on="events" />
            <button type="button" :disabled="changedisabled" class="modallist" v-b-modal.modal-kontragentlist>
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
              <button :disabled="changedisabled" type="button" class="pluss" @click="kontragent.name = search" v-b-modal.modal-kontragent>
                +
              </button>
              <b>insert</b>
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item" style="min-width: 160px;">
        <label>{{ $t("Тўлов тури") }}</label>
        <v-select :disabled="changedisabled" :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
          v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
          <template #list-footer>
            <li style="text-align: center;font-weight:bold;">
              f4 {{ $t("умумий рўйхат") }}
            </li>
          </template>
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" />
            <button :disabled="changedisabled" type="button" class="modallist" v-b-modal.modal-paytypelist>
              <b-icon icon="three-dots"></b-icon>
            </button>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="field-item">
        <label>Расход</label>
        <input :disabled="changedisabled" type="text" v-model.number="datas.rasxod_summa" class="needt input100" />
      </div>
      <div class="field-item">
        <label>Скидка</label>
        <input :disabled="changedisabled" type="text" v-model="datas.skidka_summa" class="needt input100" />
      </div>
      <!-- QARZ VALYUTASI: dollar tanlansa default true, foydalanuvchi o'zgartirishi mumkin -->
      <div class="field-item" style="min-width: 180px;">
        <label>Қарз валютаси</label>
        <label class="debt-currency-toggle" style="display:flex;align-items:center;gap:6px;padding:6px;border:1px solid #cbd5e0;border-radius:4px;cursor:pointer;background:#f7fafc;">
          <input type="checkbox" :disabled="changedisabled" v-model="datas.debt_in_dollar" />
          <span style="font-size:13px;">
            <strong v-if="datas.debt_in_dollar">💲 DOLLAR'da</strong>
            <strong v-else>₸ СЎМ'da</strong>
            qarz yoziladi
          </span>
        </label>
      </div>
      <!-- TANNARX VALYUTASI: to'lov turidan MUSTAQIL. Jadvalga qaysi valyutada
           narx kiritilayotganini bildiradi va serverga cost_currency bo'lib boradi. -->
      <div class="field-item" style="min-width: 210px;">
        <label>Таннарх валютаси</label>
        <select :disabled="changedisabled" v-model.number="datas.cost_currency"
                class="needt input100" style="font-weight:600;">
          <option :value="1">₸ СЎМ — narxlar so'mda</option>
          <option :value="2">💲 DOLLAR — narxlar dollarda</option>
        </select>
      </div>
    </div>

    <!-- ⚠️ "So'm qiymat dollar deb kiritilgan" gumoni -->
    <div v-if="costCurrencyWarning"
         style="margin:6px 10px;padding:8px 12px;border-radius:6px;background:#fff5f5;border:1px solid #fc8181;color:#9b2c2c;font-size:13px;font-weight:600;">
      ⚠️ {{ costCurrencyWarning }}
    </div>
    <div v-else-if="isDollarCost && costTotalUsd > 0"
         style="margin:6px 10px;padding:6px 12px;border-radius:6px;background:#ebf8ff;border:1px solid #90cdf4;color:#2c5282;font-size:13px;">
      💲 Tannarx jami: <strong>{{ Math.round(costTotalUsd).toLocaleString() }} $</strong>
      = <strong>{{ Math.round(costTotalUsd * (parseFloat(datas.dollar_rate) || 0)).toLocaleString() }} so'm</strong>
    </div>

    <!-- TABLE SECTION -->
    <div class="table-section">
      <div class="tableparentdiv" id="tableId">
        <table class="create_table">
          <thead>
            <tr :style="'min-width: 2110px; display: grid; grid-template-columns:'+width1">
              <th colspan="4" class="tovar">Товар</th>
              <th colspan="2" class="kolvo">{{$t('Кол-во')}}</th>
              <th colspan="3" class="kirim">
                {{$t('Нарх')}}
                <span class="cur-badge" :class="isDollarPay ? 'cur-dollar' : 'cur-sum'">
                  {{ isDollarPay ? '$ DOLLAR' : "₸ СЎМ" }}
                </span>
              </th>
              <th colspan="2" class="kirim">{{$t('Обш')}} сумма
                <span class="cur-badge" :class="isDollarPay ? 'cur-dollar' : 'cur-sum'">
                  {{ isDollarPay ? '$' : "сўм" }}
                </span>
              </th>
              <th colspan="2" class="nasenka">{{$t('Наценка %')}}</th>
              <th colspan="2" class="sena">{{$t('Чакана')}} {{ $t("Нарх") }}</th>
              <th colspan="2" class="sena">{{$t('Улгуржи')}} {{ $t("Нарх") }}</th>
              <th></th>
            </tr>
          </thead>
          <thead style="padding: 0.1% 0.2% 0 0.2%!important;">
            <tr :style="'min-width: 2110px; display: grid; grid-template-columns:'+width2">
              <th style="background: rgb(184 204 228);" v-if="settings[0].view==true">&#8470;</th>
              <th style="background: rgb(184 204 228);" v-if="settings[1].view==true">Штрих код</th>
              <th style="background: rgb(184 204 228);" v-if="settings[2].view==true">{{$t('Номи')}}</th>
              <th style="background: rgb(184 204 228);" v-if="settings[3].view==true">{{ $t("Қолдиқ") }}</th>
              <th style="background: rgb(230 184 183);" v-if="settings[16].view==true">{{$t(settings[16].column)}}</th>
              <th style="background: rgb(230 184 183);" v-if="settings[4].view==true">{{ $t("Штук") }}</th>
              <th style="background: rgb(216 228 188);" v-if="settings[17].view==true">{{$t(settings[17].column)}}</th>
              <th style="background: rgb(216 228 188);" v-if="settings[5].view==true">{{ $t("Штук") }}</th>
              <th style="background: rgb(216 228 188);" v-if="settings[7].view==true">{{ $t("Себес.") }}</th>
              <th style="background: rgb(216 228 188);" v-if="settings[6].view==true">Сумма</th>
              <th style="background: rgb(216 228 188);" v-if="settings[8].view==true">{{ $t("Себес.") }}</th>
              <th style="background: rgb(183 222 232);" v-if="settings[9].view==true">{{ $t("Чакана") }}</th>
              <th style="background: rgb(183 222 232);" v-if="settings[12].view==true">{{ $t("Улгуржи") }}</th>
              <th style="background: rgb(252 213 180);" v-if="settings[10].view==true">Сўм</th>
              <th style="background: rgb(252 213 180);color:green!important;" v-if="settings[11].view==true" >$</th>
              <th style="background: rgb(252 213 180);" v-if="settings[13].view==true">Сўм</th>
              <th style="background: rgb(252 213 180);color:green!important;" v-if="settings[14].view==true">$</th>
              <th v-if="settings[15].view==true"></th>
            </tr>
          </thead>
          <tbody style="overflow: hidden;">
            <div class="virtual" style="overflow-y: scroll; height: calc(100vh - 325px) !important; min-width: 2110px;">
              <tr :style="'min-width: 2110px; display: grid; grid-template-columns:'+width2" v-for="(item, index) in datas.prixod_table" :key="index">
                <td class="tovar" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[0].view==true">{{ index + 1 }}</td>
                <td class="tovar" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[1].view==true">
                  <input :disabled="changedisabled" class="table-input" style="text-align: left;" type="text" v-model="item.shtrix_kod"
                    @change="Shtrix(index)" />
                </td>
                <td class="tovar" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[2].view==true">
                  <v-select style="width: 100%;" :disabled="changedisabled" v-if="productlist != null" :filter-by="$store.state.myFilter" :clearable="false"
                    class="form-control-sm required" @search="query => (search = query)" :options="paginated"
                    menu-props="auto" v-model="item.product_id" :reduce="extra_name => extra_name.id" label="extra_name"
                    @input="Productchange(index)">
                    <template #list-footer>
                      <li style="text-align: center;font-weight:bold;">
                        f4 {{ $t("умумий рўйхат") }}
                      </li>
                    </template>
                    <template #selected-option-container="{option}">
                      <div class="vs__selected">
                        <span v-if="typeof option.extra_name === 'number'">{{
                          Label(option.extra_name)
                          }}</span><span v-else>{{ option.extra_name }}</span>
                      </div>
                    </template>
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes"></span>
                      <button :disabled="changedisabled" type="button" class="modallist" @click="Selectproduct(index)">
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template #selected-option="{ extra_name }">
                      <div style="position: absolute">
                        {{ extra_name }}
                      </div>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button type="button" class="pluss" @click="CreateProduct(index, search)">
                          +</button><b>Insert</b>
                      </template>
                      <em style="opacity: 0.5" v-else>{{
                        $t("Маьлумот йўқ")
                        }}</em>
                    </template>
                    <template #search="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                    </template>
                  </v-select>
                </td>
                <td class="tovar" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[3].view==true">
                  {{ item.current_balance | numFormat0 }}
                </td>
                <td  class="kolvo"  style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[16].view==true">
                  <vue-numeric :disabled="changedisabled" separator="space" decimal-separator="." style="text-align: center;" v-bind:precision="2" v-model="item.pack_count"
                  class="table-input" @input="Changepack(index)"></vue-numeric>
                </td>
                <td class="kolvo" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[4].view==true">
                  <vue-numeric :disabled="changedisabled" separator="space" decimal-separator="." style="text-align: center;" v-bind:precision="2" v-model="item.count"
                    class="table-input" @input="Changecount(index)"></vue-numeric>
                </td>
                <td class="kirim" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[17].view==true">
                  <vue-numeric :disabled="changedisabled" separator="space" decimal-separator="." v-bind:precision="2" style="text-align: center;"
                    v-model="item.pack_price" class="table-input" @input="Changepackprice(index)"></vue-numeric>
                </td>
                <td  class="kirim"  style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[5].view==true">
                  <vue-numeric :disabled="changedisabled" separator="space" decimal-separator="." v-bind:precision="2" style="text-align: center;"
                    v-model="item.kontragent_price" class="table-input" @input="Changeprice(index)"></vue-numeric>
                </td>
                <td class="kirim" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[7].view==true">
                  {{ item.debit_price | numFormat3 }}
                </td>
                <td class="kirim kol" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[6].view==true">
                  {{ item.kontragent_summa | numFormat }}
                </td>
                <td class="kirim kol" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[8].view==true" >{{ item.debit_summa | numFormat
                  }}</td>
                <td class="nasenka" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[9].view==true">
                  <input type="number"  :disabled="changedisabled" separator="space" style="text-align: center;" v-bind:precision="1" v-model="item.chakana_percent"
                    class="table-input" @input="Changepercentchakana(index)">
                </td>
                <td class="nasenka" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[12].view==true">
                  <input type="number" :disabled="changedisabled" separator="space" style="text-align: center;" v-bind:precision="1" v-model="item.optom_percent"
                    class="table-input" @input="Changepercentoptom(index)">
                </td>
                <td class="sena" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[10].view==true">
                  <vue-numeric :disabled="changedisabled" style="text-align: center;" separator="space" decimal-separator="." v-bind:precision="2"
                    v-model="item.chakana_price" class="table-input" @change="Changepricechakana(index)"></vue-numeric>
                </td>
                <td class="sena" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[11].view==true">
                  <vue-numeric :disabled="changedisabled" style="text-align: center;color:green!important;" separator="space" decimal-separator="." v-bind:precision="3"
                    v-model="item.chakana_dollar_price" class="table-input" @change="Changepricechakanadollar(index)">
                  </vue-numeric>
                </td>
                <td class="sena" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[13].view==true">
                  <vue-numeric :disabled="changedisabled" style="text-align: center;" separator="space" decimal-separator="." v-bind:precision="2"
                    v-model="item.optom_price" class="table-input" @change="Changepriceoptom(index)"></vue-numeric>
                </td>
                <td class="sena" style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[14].view==true">
                  <vue-numeric :disabled="changedisabled" style="text-align: center;color:green!important;" separator="space" decimal-separator="." v-bind:precision="3"
                    v-model="item.optom_dollar_price" class="table-input" @change="Changepriceoptomdollar(index)">
                  </vue-numeric>
                </td>
                <td  style="display: flex; justify-content: center; align-items: center; padding: 5px !important;" v-if="settings[15].view==true">
                  <a v-if="changedisabled==false" href="javascript:void(0)" class="circul trash" @click="Trashitem(index)">
                    <b-icon icon="trash"></b-icon>
                  </a>
                </td>
              </tr>
            </div>
          </tbody>
         <thead>
            <tr :style="'min-width: 2110px; display: grid; grid-template-columns:'+width2">
              <th class="tovar" v-if="settings[0].view==true"></th>
              <th class="tovar" v-if="settings[1].view==true"></th>
              <th class="tovar" v-if="settings[2].view==true"></th>
              <th class="tovar" v-if="settings[3].view==true"></th>
              <th class="kolvo" v-if="settings[16].view==true"></th>
              <th class="kolvo" v-if="settings[4].view==true">{{ datas.count_all|numFormat}}</th>
              <th class="kolvo" v-if="settings[5].view==true"></th>
              <th class="kirim" v-if="settings[17].view==true"></th>
              <th class="kirim" v-if="settings[7].view==true"></th>
              <th class="kirim" v-if="settings[6].view==true">{{datas.summa|numFormat}}</th>
              <th class="kirim" v-if="settings[8].view==true">{{datas.prixod_summa|numFormat}}</th>
              <th class="nasenka" v-if="settings[9].view==true"></th>
              <th class="nasenka" v-if="settings[12].view==true"></th>
              <th class="sena" v-if="settings[10].view==true"></th>
              <th class="sena" v-if="settings[11].view==true"></th>
              <th class="sena" v-if="settings[13].view==true"></th>
              <th class="sena" v-if="settings[14].view==true"></th>
              <th  v-if="settings[15].view==true"></th>
            </tr>
          </thead>
        </table>
      </div>
    </div>

    <!-- BOTTOM BAR -->
    <div class="form-footer">
      <div style="display: flex; align-items: center; gap: 8px;">
        <label style="white-space: nowrap; font-weight: 600; color: #64748b;">Комментарий</label>
        <textarea :disabled="changedisabled" rows="1" v-model="datas.comment" class="needt form-control" type="text"></textarea>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
        <button :disabled="changedisabled" class="footer-btn add-row-btn" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" type="button" class="footer-btn" v-b-modal.modal-settings>
          <b-icon icon="gear"></b-icon>
        </button>
        <span v-if="changedisabled==false">
        <button :disabled="sending" class="footer-btn" type="button" href="javascript:void(0)" @click="RasxodXisob()">Расход</button>
        <button class="footer-btn" type="button" @click="downloadExl()">
          <b-icon icon="cloud-download"></b-icon> Excel
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('a4')">
          <b-icon icon="printer"></b-icon> A4
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('print')">
          <b-icon icon="printer"></b-icon> Чек<sup>F7</sup>
        </button>
        <button :disabled="sending" class="footer-btn" id="chek" type="button" @click="Savedokument('barcode')">
          <b-icon icon="upc-scan"></b-icon> Barcode
        </button>
        <!-- 🏷 Tezkor shtrix modal (Kirim/Index.vue bilan bir xil) -->
        <button class="footer-btn" type="button" @click="openBcModalFromForm()" title="Tezkor shtrix chiqarish">
          <b-icon icon="upc"></b-icon> 🏷 Tezkor
        </button>
        <button :disabled="sending" class="btn-save" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button  :disabled="sending" class="btn-save-close" type="button" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
        </span>
      </div>
    </div>

    <!-- SETTINGS MODAL -->
    <b-modal id="modal-settings" hide-footer size="xl" @shown="Shoved" @hidden="SaveSettings()">
      <div class="modal-table-wrapper">
        <table class="modal-table">
          <thead>
            <th>{{$t('Номи')}}</th>
            <th>{{$t('Кўрсатиш')}}</th>
            <th>{{$t('Ўлчами')}}</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in settings" :key="index">
              <td>{{$t(item.column)}}</td>
              <td>
                <input type="checkbox" v-model="item.view">
              </td>
              <td>
                <input type="number" v-model="item.width">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- SHTRIX MODAL -->
    <b-modal id="modal-shtrix" title="Товар" hide-footer size="xl" @shown="Shoved" @hidden="Hide()">
      <div class="modal-table-wrapper">
        <div class="search-wrapper">
          <input type="text" class="form-control searchtable" v-bind:placeholder="$t('Қидирув')" v-model="filter"
            ref="inputText2" />
        </div>
        <table class="modal-table">
          <thead>
            <tr>
              <th>&#8470;</th>
              <th>{{ $t("Номи") }}</th>
              <th>{{ $t("Қолдиқ") }}</th>
              <th>{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
              <th>{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
              <th>Штрих</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in filteredRows" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.extra_name }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    ">
                  {{ item.balance }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].chakana_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.price_register[0]">
                  {{ item.price_register[0].optom_price }}
                </button>
              </td>
              <td>
                <button type="button" class="noborder" @click="
                      datas.prixod_table[settedindex].product_id =
                        item.product_id;
                      Productchange(settedindex);
                      $bvModal.hide('modal-shtrix');
                    " v-if="item.shtrix_table[0]">
                  {{ item.shtrix_table[0].shtrix_kod }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <!-- ═══════════════ 🏷 SHTRIX MODAL (Form ichida — prixod_table'dan) ═══════════════ -->
    <div v-if="bcModal.show" class="bc-overlay" @click.self="bcModal.show = false">
      <div class="bc-modal">
        <div class="bc-head">
          <h3 class="bc-title">
            🏷 Prixod #{{ datas.number || '—' }} shtrixlari
            <span class="bc-sub">({{ bcModal.list.length }} ta mahsulot)</span>
          </h3>
          <button class="bc-close" @click="bcModal.show = false">&times;</button>
        </div>
        <div class="bc-body">
          <div class="bc-options">
            <div class="bc-opt">
              <label class="bc-label">Narx turi</label>
              <select v-model="bcModal.priceType" class="bc-select">
                <option value="chakana">Chakana</option>
                <option value="optom">Optom</option>
              </select>
            </div>
            <div class="bc-opt">
              <label class="bc-toggle">
                <input type="checkbox" v-model="bcModal.showPrice"> Narxni chop etish
              </label>
            </div>
            <div class="bc-opt bc-bulk">
              <label class="bc-label">Hammaga son</label>
              <div class="bc-bulk-row">
                <input v-model.number="bcModal.bulkCount" type="number" min="0"
                  class="bc-qty" placeholder="5" @keyup.enter="applyBcBulk()" />
                <button class="bc-btn-apply" @click="applyBcBulk()" :title="bcSelectedCount > 0 ? `${bcSelectedCount} ta tanlanganga` : 'Hammasiga'">
                  Qo'llash
                </button>
              </div>
            </div>
            <div class="bc-opt" style="margin-left:auto">
              <button class="bc-btn-clear" @click="bcModal.list.forEach(it => it.count = 0)">
                <b-icon icon="x-circle"></b-icon> Sonlarni 0
              </button>
            </div>
          </div>

          <div v-if="bcModal.list.length === 0" class="bc-empty">Prixodda mahsulot yo'q.</div>
          <table v-else class="bc-table">
            <thead>
              <tr>
                <th style="width:36px; text-align:center">
                  <input type="checkbox"
                    :checked="bcAllSelected"
                    :indeterminate.prop="bcSelectedCount > 0 && !bcAllSelected"
                    @change="toggleBcSelectAll($event)"
                    title="Hammasini tanlash" />
                </th>
                <th style="width:40px">№</th>
                <th>Mahsulot</th>
                <th style="width:150px">Shtrix</th>
                <th style="width:120px">Narx</th>
                <th style="width:100px">Soni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in bcModal.list" :key="i"
                :class="{ 'bc-no-code': !it.shtrix_kod, 'bc-row-selected': it.selected }">
                <td style="text-align:center">
                  <input type="checkbox" v-model="it.selected" :disabled="!it.shtrix_kod" />
                </td>
                <td>{{ i + 1 }}</td>
                <td>
                  <div class="bc-pname">{{ it.name }}</div>
                  <div v-if="!it.shtrix_kod" class="bc-warn">⚠️ Shtrix yo'q</div>
                </td>
                <td class="bc-mono">{{ it.shtrix_kod || '—' }}</td>
                <td>{{ Number(bcModal.priceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }}</td>
                <td><input v-model.number="it.count" type="number" min="0" class="bc-qty" /></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" style="text-align:right; font-weight:800">
                  Tanlangan: <b style="color:#5850ec">{{ bcSelectedCount }}</b> ta · JAMI:
                </td>
                <td style="font-weight:900; color:#5850ec">{{ bcTotalStickers }} ta</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="bc-foot">
          <button class="bc-btn-cancel" @click="bcModal.show = false">Bekor</button>
          <button class="bc-btn-print"
            :disabled="!bcModal.list.some(it => it.selected && it.shtrix_kod && it.count > 0)"
            @click="printBcFromForm()">
            <b-icon icon="printer-fill"></b-icon> Chop etish ({{ bcTotalStickers }} ta)
          </button>
        </div>
      </div>
    </div>

    <!-- Yashirin print markup -->
    <div class="bc-mybody" style="display:none">
      <span v-for="(it, i) in bcModal.list" :key="'p'+i">
        <template v-if="it.selected && it.shtrix_kod && it.count > 0">
          <div v-for="n in Number(it.count)" :key="'p'+i+'-'+n" class="bc-page">
            <div class="bc-name">{{ it.name }}</div>
            <div v-if="bcModal.showPrice" class="bc-price">
              {{ Number(bcModal.priceType === 'chakana' ? it.chakana_price : it.optom_price).toLocaleString('ru-RU') }} so'm
            </div>
            <div class="bc-barcode-wrap">
              <barcode :value="it.shtrix_kod" width="3.5" height="110" font-size="22" displayValue></barcode>
            </div>
          </div>
        </template>
      </span>
    </div>
  </div>
</template>
<script>
  import { print } from "../../components/mixins/print.js";
  import $ from "jquery";
  import VueBarcode from 'vue-barcode';
  var XLSX = require("xlsx");
  var FileSaver = require("file-saver");
  export default {
    name: "KirimForm",
    mixins: [print],
    components: { barcode: VueBarcode },
    data() {
      return {
        // 🏷 Barcode modal (Kirim/Index.vue bilan bir xil pattern)
        bcModal: {
          show: false,
          priceType: 'chakana',
          showPrice: true,
          bulkCount: 1,
          list: [],
        },
        settings: [
          { 'column': '№', 'width': 70, 'view': true },
          { 'column': 'shtrix_kod', 'width': 120, 'view': true },
          { 'column': 'product_id', 'width': 300, 'view': true },
          { 'column': 'current_balance', 'width': 100, 'view': true },
          { 'column': 'count', 'width': 100, 'view': true },
          { 'column': 'kontragent_price', 'width': 100, 'view': true },
          { 'column': 'kontragent_summa', 'width': 120, 'view': true },
          { 'column': 'debit_price', 'width': 100, 'view': true },
          { 'column': 'debit_summa', 'width': 120, 'view': true },
          { 'column': 'chakana_percent', 'width': 100, 'view': true },
          { 'column': 'chakana_price', 'width': 100, 'view': true },
          { 'column': 'chakana_dollar_price', 'width': 100, 'view': true },
          { 'column': 'optom_percent', 'width': 100, 'view': true },
          { 'column': 'optom_price', 'width': 100, 'view': true },
          { 'column': 'optom_dollar_price', 'width': 100, 'view': true },
          { 'column': 'del', 'width': 70, 'view': true },
          { 'column': 'pack_count', 'width': 100, 'view': true },
          { 'column': 'pack_price', 'width': 100, 'view': true }
        ],
        kontragent: "",
        shtrixlist: [],
        settedindex: null,
        sklad: "",
        paytype: "",
        filter: "",
        focusset: "",
        kontragentlist: [],
        skladlist: [],
        paytypelist: []
      };
    },
    props: ["datas"],
    created: function () {
      let self = this;
      self.$root.$refs.prixod = self;
      self.$root.$on("kontragentone", function (getdata) {
        self.kontragent = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        // Kirim — faqat ta'minotchilar (type=2). Mijozlar (type=1) bu yerda chiqmasligi kerak.
        self.kontragentlist = (getdata || []).filter(k => Number(k.type) === 2);
      });
      // To'g'ridan-to'g'ri ta'minotchilar ro'yxatini yuklaymiz (event kelmasa zaxira)
      axios.get('api/v1/kontragent/type/2').then(function (r) {
        if (!self.kontragentlist || self.kontragentlist.length === 0) {
          self.kontragentlist = r.data || [];
        }
      }).catch(function () {});
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("paytypeone", function (getdata) {
        self.paytype = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.datas.prixod_table[
            this.$store.state.selected_index
          ].product_id = parseInt(localStorage.getItem("setted_product"));
          if (this.$store.state.selected_index != null) {
            this.Productchange(this.$store.state.selected_index);
          }
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
          localStorage.setItem("created_at_dok", this.datas.created_at);
        }, 1000);
    },
    mounted: function () {
      // this.datas.created_at=this.SetDatetime(this.datas.created_at);
      setTimeout(() => {
        this.Focus();
        this.SetRule('/kirim/index');
      }, 100);
      this.Settings();

    },
    methods: {
      // ════════ 🏷 BARCODE MODAL (Form ichida) ════════
      openBcModalFromForm() {
        const rows = (this.datas && this.datas.prixod_table) || [];
        this.bcModal.list = rows.map(r => ({
          name: (r.product && (r.product.extra_name || r.product.name)) || '—',
          shtrix_kod: r.shtrix_kod || '',
          chakana_price: Number(r.chakana_price || 0),
          optom_price:   Number(r.optom_price   || 0),
          count: Math.max(1, Math.floor(Number(r.count || 1))),
          selected: !!(r.shtrix_kod),
        }));
        this.bcModal.show = true;
      },

      toggleBcSelectAll(e) {
        const check = e.target.checked;
        this.bcModal.list.forEach(it => { if (it.shtrix_kod) it.selected = check; });
      },

      applyBcBulk() {
        const n = Math.max(0, Math.floor(Number(this.bcModal.bulkCount || 0)));
        const hasSelected = this.bcSelectedCount > 0;
        this.bcModal.list.forEach(it => {
          if (!it.shtrix_kod) return;
          if (hasSelected ? it.selected : true) it.count = n;
        });
      },

      printBcFromForm() {
        const valid = this.bcModal.list.filter(it => it.selected && it.shtrix_kod && Number(it.count) > 0);
        if (!valid.length) { alert("Tanlangan va soni > 0 bo'lgan mahsulot yo'q"); return; }
        this.$nextTick(() => {
          setTimeout(() => {
            const html = $('.bc-mybody').html();
            if (!html) { alert('Print markup tayyor emas'); return; }
            const w = window.open('', '_blank', 'width=420,height=700');
            w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shtrix</title>
              <style>
                @page { size: 58mm 40mm; margin: 0; }
                * { box-sizing: border-box; }
                html, body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
                .bc-page {
                  width: 58mm; height: 40mm;
                  page-break-after: always; page-break-inside: avoid;
                  display: flex; flex-direction: column;
                  align-items: center; justify-content: center;
                  gap: 0.5mm; padding: 1mm 0; overflow: hidden;
                }
                .bc-page:last-child { page-break-after: auto; }
                .bc-name {
                  font-size: 8pt; font-weight: 800;
                  text-align: center; line-height: 1.1;
                  max-height: 8mm; overflow: hidden;
                  width: 100%; word-break: break-word; padding: 0 1mm;
                }
                .bc-price { font-size: 13pt; font-weight: 900; text-align: center; line-height: 1; }
                .bc-barcode-wrap {
                  width: 100%;
                  display: flex; justify-content: center; align-items: center;
                  flex: 1; overflow: hidden;
                }
                .vue-barcode-element { width: 100% !important; display: block; }
                .vue-barcode-element svg {
                  width: 100% !important;
                  height: auto !important;
                  max-height: 26mm;
                  display: block;
                  image-rendering: -webkit-optimize-contrast;
                  image-rendering: crisp-edges;
                  shape-rendering: crispEdges;
                }
                .vue-barcode-element text {
                  font-size: 11pt !important;
                  font-weight: 800 !important;
                  letter-spacing: 1.2px;
                }
              </style>
              </head><body>${html}</body></html>`);
            w.document.close();
            w.onafterprint = () => { try { w.close(); } catch (_) {} };
            setTimeout(() => {
              w.focus();
              w.print();
              setTimeout(() => { try { w.close(); } catch (_) {} }, 2000);
            }, 300);
          }, 100);
        });
      },

      downloadExl() {
        var inputFields = $("input");

// Iterate over each input field and get its value
for (var i = 0; i < inputFields.length; i++) {
  var inputValue = inputFields[i].value;
  if (inputFields[i].type != "search") {
    $(inputFields[i]).parents('td').html(inputValue);
  }
}
        setTimeout(() => {
          $('.vs__actions').html(" ");
          let wb = XLSX.utils.table_to_book(document.querySelector("#tableId")),
            wopts = {
              bookType: "xlsx",
              bookSST: false,
              type: "binary"
            };
          var wscols = [{ width: 5 }, { width: 13 }, { width: 28 }, { width: 15 }, { width: 15 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }];
          wb.Sheets.Sheet1['!cols'] = wscols;
          let wbout = XLSX.write(wb, wopts);
          FileSaver.saveAs(
            new Blob([this.s2ab(wbout)], {
              type: "application/octet-stream;charset=utf-8"
            }),
            new Date() + ".xlsx"
          );
        }, 1000);
      },
      Settings() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'prixod' }
        }).then(function (response) {
          if (response.data.data == null) {
            self.SaveSettings();
          } else {
            var value=JSON.parse(response.data.data);
            if(value.length<self.settings.length){
              for (let index = value.length; index < self.settings.length; index++) {
                value.push(self.settings[index]);
              }
            }
            self.settings = value;
          }
        });
      },
      SaveSettings() {
        let self = this;
        let stringsettings = JSON.stringify(self.settings);
        axios({
          method: "patch",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'prixod', data: stringsettings }
        }).then(function (response) {
        });
      },
      CreateProduct(index, search) {
        localStorage.setItem("product_name", search);
        localStorage.setItem("shtrix_code", this.datas.prixod_table[index].shtrix_kod);
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал create" });
        window.open(routeData.href, "_blank", "width=1400, height=1000");
      },
      handlerClose: function (event) {
        if (this.$store.state.saved == null) {
          this.$store.state.saved = null;
        } else {
          const answer = window.confirm(
            this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
          );
          if (answer) {
            this.Savedokument();
            event.returnValue = "";
          } else {
            this.$store.state.saved = null;
          }
        }
      },
      Autoadd(index) {
        if (this.datas.prixod_table.length == index + 1) {
          this.Addtable('focusnot');
        }
      },
      Shoved() {
        let self = this;
        $(document).on("focusout", function (e) {
          if ($(e.target).attr("class") == "vs__search") {
            if (self.focusset == "") {
              self.focusset = e.target;
            }
          }
        });
        self.$refs.inputText2.focus();
      },
      Hide() {
        let self = this;
        setTimeout(function (e) {
          var classs = $(":focus");
          var rrr = $("body")
            .find("input,select,textarea,button")
            .filter(":visible");
          if (classs.attr("class") == "vs__search") {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              var focused = rrr.eq(rrr.index(classs) + 2);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          } else if (classs.attr("class") == undefined) {
            if (
              $(self.focusset)
                .siblings(".vs__selected")
                .attr("class") != undefined
            ) {
              focused = rrr.eq(rrr.index($(self.focusset)) + 3);
              focused.focus();
            } else {
              $(self.focusset).focus();
            }
          }
        }, 100);
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.summa -= this.datas.prixod_table[index].kontragent_summa;
          this.datas.prixod_summa -= this.datas.prixod_table[index].debit_summa;
          this.datas.count_all -= this.datas.prixod_table[index].count;
          this.datas.prixod_table.splice(index, 1);
        }
      },
      Productchange(index) {
        if(this.changedisabled==false){
        let self = this;
        var item = self.datas.prixod_table[index];
        item.optom_price = 0;
        item.chakana_price = 0;
        axios({
          method: "post",
          url: "api/v1/product/price-balance",
          data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          if (self.isDollarCost) {
            item.current_balance = response.data.balance;
            if (response.data.price_type == 2) {
              item.kontragent_price = response.data.delivery_price;
              item.pack_price=item.pack_norma*response.data.delivery_price;
              item.debit_price = response.data.delivery_price;
            } else if (response.data.price_type == 1) {
              item.kontragent_price = response.data.delivery_price/self.datas.dollar_rate;
              item.pack_price=item.pack_norma*response.data.delivery_price/self.datas.dollar_rate;
              item.debit_price = response.data.delivery_price/self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_price = response.data.optom_dollar_price*self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
            item.optom_percent = parseFloat((response.data.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_price = response.data.chakana_dollar_price*self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
              item.chakana_percent = parseFloat((response.data.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            }
          } else {
            item.current_balance = response.data.balance;
            if (response.data.price_type == 1) {
              item.kontragent_price = response.data.delivery_price;
              item.debit_price = response.data.delivery_price;
              item.pack_price = response.data.delivery_price*item.pack_price;
            } else if (response.data.price_type == 2) {
              item.kontragent_price = response.data.delivery_price*self.datas.dollar_rate;
              item.pack_price=item.pack_norma*response.data.delivery_price*self.datas.dollar_rate;
              item.debit_price = response.data.delivery_price*self.datas.dollar_rate;
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_dollar_price = response.data.optom_price/self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
              item.optom_percent = parseFloat((response.data.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_dollar_price = response.data.chakana_price/self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
              item.chakana_percent = parseFloat((response.data.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            }
          }
          setTimeout(() => {
            // self.Changeprice(index);
          }, 100);
        });
          axios({
            method: "get",
            url: "api/v1/product/id/" + item.product_id
          }).then(function (response) {
            item.pack_norma = response.data.pack_count;
            const existing = response.data.shtrix_table && response.data.shtrix_table[0]
              ? response.data.shtrix_table[0].shtrix_kod
              : '';
            if (existing) {
              item.shtrix_kod = existing;
            } else if (item.product_id) {
              // 🆕 Mahsulot uchun shtrix kod yo'q — avtomatik 25 + product.id formuli
              // bo'yicha noyob shtrix beramiz. Prixod saqlanganda backend uni products
              // shtrix jadvaliga ham yozadi (ShtrixModel.findOrCreate).
              item.shtrix_kod = String(25 * 100000000000 + Number(item.product_id));
            }
          });
        }
      },
      Focus() {
        if (this.$route.path == "/kirim/create") {
          this.$refs.focused.focus();
        } else {
          setTimeout(() => {
            $(".table-input")
              .eq(2)
              .focus();
          }, 100);

        }
      },
      Shtrix(index) {
        let self = this;
        var shtrix = self.datas.prixod_table[index].shtrix_kod;
        axios({
          method: "post",
          url: "api/v1/product/shtrix2/" + shtrix,
          data: { sklad_id: self.datas.sklad_id }
        }).then(function (response) {
          console.log(response);
          if (!response.data[0]) {
          } else if (response.data[1]) {
            self.settedindex = index;
            self.shtrixlist = response.data;
            self.$bvModal.show("modal-shtrix");
          } else {
            self.datas.prixod_table[index].product_id =
              response.data[0].product_id;
            self.Productchange(index);
            var classs = $(":focus");
            var rrr = $("body")
              .find("input,select,textarea,button")
              .filter(":visible");
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          }
        });
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      RasxodXisobPercent(){
        if(this.changedisabled==false){
        let self = this;
        if (self.datas.rasxod_summa != 0 && self.datas.summa) {
          var ortacharasxod = self.datas.rasxod_summa / self.datas.summa;
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price =
              parseFloat(key.kontragent_price) +
              key.kontragent_price * ortacharasxod;
            key.debit_summa = key.debit_price * key.count;
              if (key.chakana_dollar_price > 0) {
                self.Changepercentchakana(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepercentoptom(value);
              }
          });
        } else {
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price = key.kontragent_price;
            key.debit_summa = key.debit_price * key.count;
              if (key.chakana_dollar_price > 0) {
                self.Changepercentchakana(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepercentoptom(value);
              }
           });
        }
        self.Summa();
      }
      },
      RasxodXisob() {
        if(this.changedisabled==false){
        let self = this;
        if (self.datas.rasxod_summa != 0 && self.datas.summa) {
          var ortacharasxod = self.datas.rasxod_summa / self.datas.summa;
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price =
              parseFloat(key.kontragent_price) +
              key.kontragent_price * ortacharasxod;
            key.debit_summa = key.debit_price * key.count;
            if (self.isDollarCost) {
              if (key.chakana_dollar_price > 0) {
                self.Changepricechakanadollar(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepriceoptomdollar(value);
              }
            } else {
              if (key.optom_price > 0) {
                self.Changepriceoptom(value);
              }
              if (key.chakana_price > 0) {
                self.Changepricechakana(value);
              }
            }
          });
        } else {
          self.datas.prixod_table.forEach(function (key, value) {
            key.debit_price = key.kontragent_price;
            key.debit_summa = key.debit_price * key.count;
            if (self.isDollarCost) {
              if (key.chakana_dollar_price > 0) {
                self.Changepricechakanadollar(value);
              }
              if (key.optom_dollar_price > 0) {
                self.Changepriceoptomdollar(value);
              }
            } else {
              if (key.optom_price > 0) {
                self.Changepriceoptom(value);
              }
              if (key.chakana_price > 0) {
                self.Changepricechakana(value);
              }
            }
          });
        }
        self.Summa();
      }
      },
      Changeprice(index) {
        if(this.changedisabled==false){
        var item = this.datas.prixod_table[index];
        item.pack_price=item.kontragent_price*item.pack_norma;
        let self = this;
        if (item.kontragent_price > 0) {
          item.debit_price = item.kontragent_price;
          item.debit_summa = item.debit_price * item.count;
        }
        if (self.isDollarCost) {
          if (item.chakana_dollar_price > 0) {
            // self.Changepricechakanadollar(index);
          }
          if (item.optom_dollar_price > 0) {
            // self.Changepriceoptomdollar(index);
          }
        } else {
          if (item.optom_price > 0) {
            // this.Changepriceoptom(index);
          }
          if (item.chakana_price > 0) {
            // this.Changepricechakana(index);
          }
        }
        item.kontragent_summa = item.kontragent_price * item.count;
        this.Summa();
      }
      },
      Changepackprice(index) {
        if(this.changedisabled==false){
        var item = this.datas.prixod_table[index];
        // pack_norma > 0 bo'lsagina kontragent_price hisoblash (Infinity'ni oldini olamiz)
        if (item.pack_price > 0 && parseFloat(item.pack_norma) > 0) {
          item.kontragent_price = item.pack_price / item.pack_norma;
        }
        let self = this;
        if (item.kontragent_price > 0) {
          item.debit_price = item.kontragent_price;
          item.debit_summa = item.debit_price * item.count;
        }
        if (self.isDollarCost) {
          if (item.chakana_dollar_price > 0) {
            self.Changepricechakanadollar(index);
          }
          if (item.optom_dollar_price > 0) {
            self.Changepriceoptomdollar(index);
          }
        } else {
          if (item.optom_price > 0) {
            this.Changepriceoptom(index);
          }
          if (item.chakana_price > 0) {
            this.Changepricechakana(index);
          }
        }
        item.kontragent_summa = item.kontragent_price * item.count;
        this.Summa();
      }
      },
      Changecount(index) {
        if(this.changedisabled==false){
        var item = this.datas.prixod_table[index];
        // pack_norma > 0 bo'lsagina pack_count hisoblash (NaN/Infinity'ni oldini olamiz)
        if (item.count > 0 && parseFloat(item.pack_norma) > 0) {
          item.pack_count = item.count / item.pack_norma;
        } else {
          item.pack_count = 0;
        }
        if (item.kontragent_price > 0) {
          item.kontragent_summa = item.count * item.kontragent_price;
          // this.Changepricechakana(index);
          // this.Changepriceoptom(index);
        }
        if (item.debit_price > 0) {
          item.debit_summa = item.count * item.debit_price;
        }
        if (item.optom_price > 0) {
          item.optom_summa = item.count * item.optom_price;
        }
        if (item.chakana_price > 0) {
          item.chakana_summa = item.count * item.chakana_price;
        }
        this.Summa();
      }
      },
      Changepack(index) {
        if(this.changedisabled==false){
          var item = this.datas.prixod_table[index];
        // pack_norma > 0 bo'lsagina count hisoblash
        if (parseFloat(item.pack_norma) > 0) {
          item.count = item.pack_count * item.pack_norma;
        } else {
          item.count = item.pack_count || 0;
        }
        if (item.kontragent_price > 0) {
          item.kontragent_summa = item.count * item.kontragent_price;
          // this.Changepricechakana(index);
          // this.Changepriceoptom(index);
        }
        if (item.debit_price > 0) {
          item.debit_summa = item.count * item.debit_price;
        }
        if (item.optom_price > 0) {
          item.optom_summa = item.count * item.optom_price;
        }
        if (item.chakana_price > 0) {
          item.chakana_summa = item.count * item.chakana_price;
        }
        this.Summa();
        }
      },
      Changepercentoptom(index) {
        var item = this.datas.prixod_table[index];
        if (this.isDollarCost) {
          item.optom_dollar_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_summa = item.optom_price * item.count;
          item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
        }
      },
      Changepercentchakana(index) {
        var item = this.datas.prixod_table[index];
        if (this.isDollarCost) {
          item.chakana_dollar_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
        }
      },
      Changepriceoptom(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          if (this.isDollarCost) {
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
          }
        }
      },
      Changepriceoptomdollar(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          if (this.isDollarCost) {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          }
        }
      },
      Changepricechakana(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          if (this.isDollarCost) {
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
          }
        }
      },
      Changepricechakanadollar(index) {
        var item = this.datas.prixod_table[index];
        if (item.debit_price > 0) {
          if (this.isDollarCost) {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
      Addtable(type = 'default') {
        this.datas.prixod_table.push({
          product_id: 0,
          current_balance: 0,
          count: 0,
          debit_price: 0,
          debit_summa: 0,
          kontragent_price: 0,
          kontragent_summa: 0,
          chakana_percent: 0,
          optom_percent: 0,
          chakana_price: 0,
          chakana_dollar_price: 0,
          optom_price: 0,
          optom_dollar_price: 0,
          chakana_summa: 0,
          optom_summa: 0,
          shtrix_kod: "",
          pack_count:0,
          pack_price:0,
          pack_norma:0
        });
        if (type == 'default') {
          this.Tablefocus();
        }
      },
      Summa() {
        this.datas.summa = 0;
        this.datas.count_all = 0;
        this.datas.prixod_summa = 0;
        let self = this;
        this.datas.prixod_table.forEach(function (key, value) {
          self.datas.summa += parseFloat(key.kontragent_summa);
          self.datas.count_all += parseFloat(key.count);
          self.datas.prixod_summa += parseFloat(key.debit_summa);
        });
      },
      Savedokument(type = "default") {
        let self = this;
        // if (self.rule.change == true) {
          if (self.sending == false) {
            // TANNARX VALYUTASI — har bir qatorga aniq yoziladi (1=so'm, 2=dollar).
            // Server endi `cost_currency` bo'lmasa SO'M deb qabul qiladi va
            // `pay_type_id` dan valyuta XULOSA QILMAYDI, shuning uchun buni
            // yuborish MAJBURIY — aks holda dollar kirim so'm bo'lib saqlanadi.
            const cur = parseInt(self.datas.cost_currency) === 2 ? 2 : 1;
            self.datas.cost_currency = cur;
            (self.datas.prixod_table || []).forEach(it => { it.cost_currency = cur; });

            // Mantiqsiz dollar qiymatda tasdiq so'raymiz (bloklamaydi)
            if (self.costCurrencyWarning &&
                !window.confirm(`⚠️ ${self.costCurrencyWarning}\n\nShunday saqlansinmi?`)) {
              return;
            }
            self.sending=true;
          if (self.datas.rasxod_summa == "") {
            self.datas.rasxod_summa = 0;
          }
          if (this.$route.path == "/kirim/create") {
            var methods = "post";
            var action = "api/v1/prixod";
            self.Summa();
          } else {
            var methods = "patch";
            var action = "api/v1/prixod/id/" + self.$route.params.id;
            if (self.$store.state.saved == 1) {
              self.Summa();
              self.datas.updated_at = new Date()
                .valueOf()
                .toString()
                .slice(0, 10);
            }
          }
          // self.datas.created_at = new Date(self.datas.created_at)
          //   .valueOf()
          //   .toString()
          //   .slice(0, 10);
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            self.sending = false;
            if (type == "print") {
              let routeData = self.$router.resolve({
                name: "printprixod",
                query: { id: response.data.id }
              });
              let myWindow;
              myWindow = window.open(
                '#/kirim/print/' + response.data.id,
                "_blank",
                "width=1000, height=1000"
              );
              self.$router.push({ name: "Кирим" });
            } else if (type == "save") {
              self.$router.push({ path: "/kirim/update/" + response.data.id });
            } else if (type == 'barcode') {
              let myWindow;
              myWindow = window.open(
                '#/kirim/barcode/' + response.data.id,
                "_blank",
                "width=500, height=800"
              );
            } else if (type == 'a4') {
              localStorage.setItem("print_type", "Копия");
              let myWindow;
              myWindow = window.open(
                '#/kirim/a4print/' + response.data.id,
                "_blank",
                "width=500, height=800"
              );
              self.$router.push({ name: "Кирим" });
            }
            else {
              self.$router.push({ name: "Кирим" });
            }
          });
          if (self.sending == true) {
            setTimeout(() => {
              self.sending = false;
            }, 3000);
          }
        }
        // } else {
          // self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    },
    watch: {
      // To'lov turi o'zgarganda FAQAT qarz valyutasi moslanadi.
      // ⚠️ Tannarx valyutasi (`cost_currency`) BU YERDA O'ZGARTIRILMAYDI — aynan shu
      //    bog'liqlik so'mda kiritilgan narxlarni dollar deb saqlab, hisobotdagi
      //    tannarxni ×kurs shishirgan edi.
      'datas.pay_type_id'(newVal, oldVal) {
        if (!this.datas) return;
        const newIsDollar = parseInt(newVal) === 3;
        if (oldVal !== undefined || this.datas.debt_in_dollar === null || this.datas.debt_in_dollar === undefined) {
          this.$set(this.datas, 'debt_in_dollar', newIsDollar);
        }
      },

      // Tannarx valyutasi o'zgarganda mahsulot narxlari avtomatik konvert qilinadi
      // (so'm → dollar: ÷ kurs, dollar → so'm: × kurs), shunda foydalanuvchi
      // qiymatni qo'lda qayta yozmaydi va "so'm dollar bo'lib qoldi" holati bo'lmaydi.
      'datas.cost_currency'(newVal, oldVal) {
        if (!this.datas || oldVal === undefined) return;
        const newIsDollar = parseInt(newVal) === 2;
        const oldIsDollar = parseInt(oldVal) === 2;
        if (newIsDollar === oldIsDollar) return;

        const rate = parseFloat(this.datas.dollar_rate || 0);
        if (!(rate > 0) || !Array.isArray(this.datas.prixod_table)) return;

        const factor = newIsDollar ? (1 / rate) : rate; // sum→$ bo'lsa /rate, $→sum bo'lsa ×rate
        const dp = newIsDollar ? 4 : 2;
        this.datas.prixod_table.forEach(it => {
          if (parseFloat(it.kontragent_price) > 0) {
            it.kontragent_price = +(it.kontragent_price * factor).toFixed(dp);
            it.kontragent_summa = +(it.kontragent_price * (it.count || 0)).toFixed(dp);
            it.debit_price = it.kontragent_price;
            it.debit_summa = +(it.debit_price * (it.count || 0)).toFixed(dp);
            if (parseFloat(it.pack_norma) > 0) {
              it.pack_price = +(it.kontragent_price * it.pack_norma).toFixed(dp);
            }
          }
        });
        this.Summa();
      },
    },
    computed: {
      // 🏷 Barcode modal computed
      bcSelectableItems() { return (this.bcModal.list || []).filter(it => it.shtrix_kod); },
      bcSelectedCount() { return (this.bcModal.list || []).filter(it => it.selected).length; },
      bcAllSelected() {
        const items = this.bcSelectableItems;
        return items.length > 0 && items.every(it => it.selected);
      },
      bcTotalStickers() {
        return (this.bcModal.list || [])
          .filter(it => it.selected && it.shtrix_kod)
          .reduce((s, it) => s + Number(it.count || 0), 0);
      },

      // ⚠️ TANNARX VALYUTASI — TO'LOV TURIDAN MUSTAQIL.
      // Ilgari `pay_type_id === 3 (Dollar)` valyuta sifatida ishlatilardi. Ammo
      // ta'minotchiga DOLLARDA TO'LASH narxlar DOLLARDA KIRITILGANINI bildirmaydi.
      // Foydalanuvchi dollarda to'lab, narxlarni so'mda kiritsa — butun hujjat
      // dollar deb saqlanib, tannarx ×kurs (12 210 barobar) shishib ketardi.
      // Endi valyuta faqat shu maydondan olinadi va serverga `cost_currency` bilan
      // aniq yuboriladi (1 = so'm, 2 = dollar).
      isDollarCost() {
        return parseInt(this.datas && this.datas.cost_currency) === 2;
      },
      // Eski nom — shablonda ishlatiladi
      isDollarPay() {
        return this.isDollarCost;
      },
      // Dollar deb belgilangan hujjatning jami (dollarda) — mantiqsizlikni ko'rsatish uchun
      costTotalUsd() {
        if (!this.isDollarCost || !this.datas || !Array.isArray(this.datas.prixod_table)) return 0;
        return this.datas.prixod_table.reduce((acc, it) => {
          return acc + (parseFloat(it.kontragent_price) || 0) * (parseFloat(it.count) || 0);
        }, 0);
      },
      // "So'm qiymat dollar deb kiritilgan" gumoni — backend bilan bir xil chegaralar
      // (backend/src/utils/costCurrency.utils.js)
      costCurrencyWarning() {
        if (!this.isDollarCost) return null;
        const rate = parseFloat(this.datas.dollar_rate || 0) || 1;
        const rows = (this.datas.prixod_table || []).filter(it => parseInt(it.product_id) > 0);
        const maxUnit = rows.reduce((m, it) => Math.max(m, parseFloat(it.kontragent_price) || 0), 0);
        if (maxUnit >= 5000) {
          return `Birlik tannarx ${maxUnit.toLocaleString()} $ — bu so'm qiymatga o'xshaydi `
               + `(= ${Math.round(maxUnit * rate).toLocaleString()} so'm). Valyutani tekshiring!`;
        }
        if (this.costTotalUsd >= 100000) {
          return `Hujjat jami ${Math.round(this.costTotalUsd).toLocaleString()} $ `
               + `(= ${Math.round(this.costTotalUsd * rate).toLocaleString()} so'm) — valyutani tekshiring!`;
        }
        return null;
      },
      width1(){
        return parseInt(this.settings[0].width)+parseInt(this.settings[1].width)+parseInt(this.settings[2].width)+parseInt(this.settings[3].width)+'px '+(parseInt(this.settings[16].width)+parseInt(this.settings[4].width))+'px '+(parseInt(this.settings[5].width)+parseInt(this.settings[17].width)+parseInt(this.settings[7].width))+'px '+(parseInt(this.settings[6].width)+parseInt(this.settings[8].width))+'px '+(parseInt(this.settings[9].width)+parseInt(this.settings[12].width))+'px '+(parseInt(this.settings[10].width)+parseInt(this.settings[11].width))+'px '+(parseInt(this.settings[13].width)+parseInt(this.settings[14].width))+'px '+parseInt(this.settings[15].width)+'px';
      },
      width2(){
        return parseInt(this.settings[0].width)+'px '+parseInt(this.settings[1].width)+'px '+parseInt(this.settings[2].width)+'px '+parseInt(this.settings[3].width)+'px '+parseInt(this.settings[16].width)+'px '+parseInt(this.settings[4].width)+'px '+parseInt(this.settings[5].width)+'px '+parseInt(this.settings[17].width)+'px '+parseInt(this.settings[7].width)+'px '+parseInt(this.settings[6].width)+'px '+parseInt(this.settings[8].width)+'px '+parseInt(this.settings[9].width)+'px '+parseInt(this.settings[12].width)+'px '+parseInt(this.settings[10].width)+'px '+parseInt(this.settings[11].width)+'px '+parseInt(this.settings[13].width)+'px '+parseInt(this.settings[14].width)+'px '+parseInt(this.settings[15].width)+'px';
      },
      filteredRows() {
        return this.shtrixlist.filter(row => {
          const name = row.extra_name.toString().toLowerCase();
          const searchTerm = this.filter.toLowerCase();

          return name.includes(searchTerm);
        });
      }
    }
  };
</script>
<style>
  .fiksa table {
  border-collapse: separate;
  border-spacing: 0;
  border-top: 1px solid grey;
}

.fiksa td,
.fiksa th {
  margin: 0;
  border: 1px solid grey;
  white-space: nowrap;
  border-top-width: 0px;
}

div.fiksa {
  width: calc(100% - 200px);
  overflow-x: scroll;
  margin-left: 200px;
  overflow-y: visible;
  padding: 0;
}

.fiksa .headcol {
  position: absolute;
  /* width: 5em; */
  left: 0;
  top: auto;
  border-top-width: 1px;
  /*only relevant for first row*/
  margin-top: -1px;
  /*compensate for top border*/
}

.fiksa .headcol:before {
  /* content: 'Row '; */
}

.fiksa .long {
  /* background: yellow; */
  letter-spacing: 1em;
}
</style>
<style scoped>
/* HEADER */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: white;
  border-radius: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
}
.form-header-left {
  display: flex;
  align-items: center;
}
.form-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-header-right label {
  font-weight: 700;
  color: #64748b;
  font-size: 13px;
}
.page-title {
  font-weight: 800;
  font-size: 20px;
  color: #2c3e50;
  margin: 0;
}
.back-circle-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 12px;
  transition: 0.3s;
}
.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}
.change-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  margin-left: 12px;
}
.change-btn:hover {
  background: #a142f4;
  color: white;
}
.kurs-input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;
  width: 120px;
  font-weight: 600;
  text-align: center;
}
.kurs-input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* TOP FORM BAR */
.form-fields-bar {
  display: flex;
  gap: 10px;
  padding: 10px 15px;
  background: white;
  border-radius: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  flex-wrap: wrap;
  align-items: flex-end;
}
.field-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 100px;
}
.field-item label {
  font-size: 11px;
  font-weight: 700;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}
.field-item .input100,
.field-item input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 10px;
  font-weight: 600;
  font-size: 13px;
}
.field-item .input100:focus,
.field-item input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* TABLE SECTION */
.table-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  overflow-x: auto;
  overflow-y: hidden;
}

/* FOOTER */
.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: white;
  border-radius: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  gap: 8px;
  flex-wrap: wrap;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
.form-footer span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.footer-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
  white-space: nowrap;
}
.footer-btn:hover:not(:disabled) {
  border-color: #a142f4;
  color: #a142f4;
}
.footer-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.add-row-btn {
  background: #f0e6ff;
  color: #a142f4;
  border-color: #f0e6ff;
}
.add-row-btn:hover:not(:disabled) {
  background: #a142f4;
  color: white;
}
.btn-save {
  background: #16a34a;
  color: white;
  border: none;
  padding: 8px 20px;
  height: 38px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-save:hover:not(:disabled) {
  background: #15803d;
}
.btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-save-close {
  background: #a142f4;
  color: white;
  border: none;
  padding: 8px 20px;
  height: 38px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.btn-save-close:hover:not(:disabled) {
  background: #8b2de0;
  box-shadow: 0 4px 16px rgba(161, 66, 244, 0.35);
}
.btn-save-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* MODAL */
.modal-table-wrapper {
  padding: 10px;
}
.modal-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
}
.modal-table thead th {
  background: #f8fafc;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #e2e8f0;
}
.modal-table tbody td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.modal-table tbody tr:hover {
  background: #f8fafc;
}
.search-wrapper {
  margin-bottom: 12px;
}
.search-wrapper input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
}
.search-wrapper input:focus {
  outline: none;
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .form-fields-bar {
    gap: 8px;
  }
  .field-item {
    min-width: 130px;
  }
}

@media (max-width: 768px) {
  .form-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    padding: 10px 15px;
  }
  .form-fields-bar {
    flex-direction: column;
    padding: 10px;
  }
  .field-item {
    width: 100%;
    min-width: unset;
  }
  .form-footer {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    position: static;
  }
  .form-footer > div {
    flex-wrap: wrap;
    justify-content: center;
  }
  .form-footer span {
    justify-content: center;
  }
}
.cur-badge {
  display: inline-block;
  padding: 1px 6px;
  margin-left: 4px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 3px;
  vertical-align: middle;
}
.cur-badge.cur-dollar { background: #d1fae5; color: #065f46; }
.cur-badge.cur-sum    { background: #dbeafe; color: #1e3a8a; }

/* ═════════════ 🏷 SHTRIX MODAL ═════════════ */
.bc-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.5);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.bc-modal {
  background: white; border-radius: 20px;
  width: 900px; max-width: 96vw; max-height: 90vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
}
.bc-head {
  padding: 18px 22px; border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.bc-title { margin: 0; font-size: 18px; font-weight: 800; color: #1e293b; }
.bc-sub { font-size: 13px; color: #94a3b8; font-weight: 600; margin-left: 6px; }
.bc-close {
  background: #f1f5f9; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
}
.bc-body { padding: 16px 22px; overflow-y: auto; flex: 1; }
.bc-foot {
  padding: 14px 22px; border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}
.bc-options {
  display: flex; align-items: center; gap: 16px;
  margin-bottom: 14px; padding: 10px 14px;
  background: #f8fafc; border-radius: 10px;
}
.bc-opt { display: flex; flex-direction: column; gap: 4px; }
.bc-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
.bc-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.bc-toggle {
  display: flex; align-items: center; gap: 6px; cursor: pointer; user-select: none;
  font-size: 13px; font-weight: 600; color: #475569;
}
.bc-bulk-row { display: flex; gap: 6px; align-items: center; }
.bc-btn-apply {
  background: linear-gradient(135deg, #5850ec, #4338ca);
  color: white; border: none;
  height: 32px; padding: 0 12px; border-radius: 8px;
  font-weight: 800; font-size: 12px; cursor: pointer;
}
.bc-btn-apply:hover { opacity: 0.92; }
.bc-btn-clear {
  background: #fff1f2; color: #e11d48; border: 1.5px solid #fda4af;
  height: 36px; padding: 0 14px; border-radius: 8px;
  font-weight: 700; font-size: 12px; cursor: pointer;
}
.bc-btn-clear:hover { background: #e11d48; color: white; }
.bc-empty { text-align: center; padding: 40px 20px; color: #94a3b8; font-weight: 600; }
.bc-table { width: 100%; border-collapse: collapse; }
.bc-table th {
  background: #f8fafc; padding: 10px;
  font-size: 11px; font-weight: 800; color: #64748b;
  text-transform: uppercase; text-align: left;
  border-bottom: 1.5px solid #e8edf3;
}
.bc-table td {
  padding: 10px; border-bottom: 1px solid #f1f5f9;
  font-size: 13px; color: #1e293b;
}
.bc-pname { font-weight: 700; }
.bc-warn { font-size: 11px; color: #b91c1c; font-weight: 700; margin-top: 2px; }
.bc-mono { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #5850ec; }
.bc-qty {
  width: 80px; height: 32px;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 14px; font-weight: 700;
  text-align: center; outline: none;
}
.bc-qty:focus { border-color: #5850ec; }
.bc-row-selected { background: #f5f3ff; }
.bc-no-code { opacity: 0.6; background: #fef3f2; }
.bc-table tfoot td { background: #f1f5f9; padding: 12px 10px; }
.bc-btn-cancel {
  background: #f1f5f9; color: #64748b;
  border: none; height: 42px; padding: 0 20px;
  border-radius: 10px; font-weight: 700; cursor: pointer;
}
.bc-btn-print {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white; border: none;
  height: 42px; padding: 0 24px;
  border-radius: 10px; font-weight: 800; cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
}
.bc-btn-print:hover:not(:disabled) { opacity: 0.92; }
.bc-btn-print:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
